interface FieldsAndValuesInterface{
  label:string;
  type:string;
  value:string;
  placeholder?:string
}

export const fieldsAndValues:FieldsAndValuesInterface[] = [
  {
    label: 'Nome completo',
    type: 'text',
    value: 'fullName'
  },
  {
    label: 'Cargo',
    type: 'text',
    value: 'position'
  },
  {
    label: 'Custo por hora',
    type: 'cash',
    value: 'costPerHour',
    placeholder: 'R$ 00,00'
  },
  {
    label: 'Custo por hora extra',
    type: 'cash',
    value: 'costPerExtraHour',
    placeholder: 'R$ 00,00'
  },
  {
    label: 'Máquinas',
    type: 'text',
    value: 'machines'
  },
]